// extracted by mini-css-extract-plugin
module.exports = {"received":"tablePayments_received__1BI-Z","refunded":"tablePayments_refunded__1t3eS","removed":"tablePayments_removed__1thCk","dimmedText":"tablePayments_dimmedText__-1OUX"};